PROMISE_STATICS_INCORRECT_ITERATION